export function getFormatDate(format: string) {
	let resolvedFormat;
	switch (format) {
	case 'date':
		resolvedFormat = 'L';
		break;
	case 'datetime':
		resolvedFormat = 'L LT';
		break;
	case 'time':
		resolvedFormat = 'LT';
		break;
	case 'week':
		resolvedFormat = '[W]WW/GGGG';
		break;
	case 'month':
		resolvedFormat = '[M]MM/YYYY';
		break;
	case 'quarter':
		resolvedFormat = '[Q]Q/YYYY';
		break;
	default:
		resolvedFormat = format;
		break;
	}
	return resolvedFormat;
}

export function getParseDate(format: string) {
	let parseDate;
	switch (format) {
	case 'isoDatetime':
		parseDate = [
			'YYYY-MM-DD[T]HH:mm:ss.SSSSZ',
			'YYYY-MM-DD HH:mm:ss.SSSSZ',
			'YYYY-MM-DD[T]HH:mm:ss.SSSS',
			'YYYY-MM-DD HH:mm:ss.SSSS',
			'YYYY-MM-DD[T]HH:mm:ssZ',
			'YYYY-MM-DD HH:mm:ssZ',
			'YYYY-MM-DD[T]HH:mm:ss',
			'YYYY-MM-DD HH:mm:ss',
			'YYYY-MM-DD[T]HH:mmZ',
			'YYYY-MM-DD HH:mmZ',
			'YYYY-MM-DD[T]HH:mm',
			'YYYY-MM-DD HH:mm'
		];
		break;
	case 'isoDate':
		parseDate = ['YYYY-MM-DD'];
		break;
	case 'date':
		parseDate = [
			'DD/MM/YYYY',
			'D/M/YYYY',
			'D/M/YY',
			'D/MM/YY',
			'DD/M/YY',
			'D/MM/YYYY',
			'DD/M/YYYY',
			'DD-MM-YY',
			'DD-MM-YYYY',
			'DD/MM',
			'DD/M',
			'D/MM',
			'D/M',
			'YYYY-MM-DD',
			'DD-MM',
			'D-M',
			'DDMM',
			'DDMMYY',
			'DDMMY',
			'DD',
			'D'
		];
		break;
	case 'isoWeek':
		parseDate = [
			'GGGG-[W]WW',
			'GGGG-[w]WW'
		];
		break;
	case 'week':
		parseDate = [
			'[W]WW/GGGG',
			'[w]WW/GGGG',
			'WW/GGGG',
			'[W]W/GGGG',
			'[w]W/GGGG',
			'W/GGGG',
			'[W]WW/GG',
			'[w]WW/GG',
			'WW/GG',
			'[W]W/GG',
			'[w]W/GG',
			'W/GG',
			'GGGG-[W]WW',
			'GGGG-[w]WW',
			'[W]WW',
			'[w]WW',
			'WW',
			'[W]W',
			'[w]W',
			'W'
		];
		break;
	case 'isoMonth':
		parseDate = [
			'YYYY-[M]MM',
			'YYYY-[m]MM'
		];
		break;
	case 'quarter':
		parseDate = [
			'YYYY-[Q]Q',
			'YYYY-[q]Q'
		];
		break;
	default:
		parseDate = [format];
		break;
	}
	return parseDate;
}

export function formatInterval(start: string, end: string) {
	return `${ start }\u00A0\u2013 ${ end }`;
}
